import React from 'react';
import ReactDOM from 'react-dom/client';
import { Theme } from './config/theme';
import { ThemeProvider } from "@mui/material";
import { Provider} from 'react-redux'
import { BrowserRouter } from 'react-router-dom';
import './css/normalize.css'
import App from './App';
import store from './storage';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <BrowserRouter>
     <Provider store={store} >
     <ThemeProvider theme={Theme}>
         <App />
     </ThemeProvider>
    
     </Provider>
    
     </BrowserRouter>

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
